import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Avatar from '@material-ui/core/Avatar';
import { Link } from 'react-router-dom';
import Panel from '../../components/Panel';
import { Teams as TeamsIcon } from '../../icons';
import { TeamContext, TeamManager } from '../../components';


const styles = () => ({
  title: {
    display: 'block',
  },
  page: {
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between',
  },
  panelContent: {
    minHeight: 'calc(80vh - 5em)',
    '& *': {
      fontWeight: '500',
    },
    '& [class^="Tree-label"]': {
      '&:hover': {
        color: 'rgb(48,183,255)',
      },
    },
  },
  keys: {
    '& > *': {
      padding: '0.5em 0',
    },
  },
  titleLink: {
    color: '#1682bc',
  },
});

const Team = ({ classes, ...rest }) => (
  <div className={classes.page}>
    <Panel
      id="teamsPanel"
      title={<Link className={classes.titleLink} to={`${rest.match.url}`}>Team</Link>}
      classes={{ title: classes.title }}
      avatar={<Avatar><TeamsIcon /></Avatar>}
    >
      <div className={classes.panelContent}>
        <TeamManager
          teamId={TeamContext.getSelectedTeamId()}
          {...rest}
        />
      </div>
    </Panel>
  </div>
);

Team.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Team);
